import { render } from "./g-sidebar-page.vue?vue&type=template&id=ae8dfa92&ts=true"
import script from "./g-sidebar-page.vue?vue&type=script&lang=tsx"
export * from "./g-sidebar-page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__